import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export default function Footer() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <footer className="w-full bg-foreground-900 text-white py-12 md:py-16 px-4 md:px-8">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12 mb-10">
          {/* Brand & Social */}
          <div>
            <h3 className="text-2xl md:text-3xl font-bold tracking-wider mb-4 font-body">HIPOBUY</h3>
            <p className="text-sm text-white/70 leading-relaxed mb-6 font-body max-w-xs">
              {t("home.about.desc")}
            </p>
            <div className="flex gap-3">
              <a href="https://instagram.com" target="_blank" rel="noopener nofollow" className="w-10 h-10 flex items-center justify-center rounded-full border border-white/30 text-white hover:bg-white/10 transition-colors cursor-pointer">
                <i className="ri-instagram-line" />
              </a>
              <a href="https://tiktok.com" target="_blank" rel="noopener nofollow" className="w-10 h-10 flex items-center justify-center rounded-full border border-white/30 text-white hover:bg-white/10 transition-colors cursor-pointer">
                <i className="ri-tiktok-line" />
              </a>
              <a href="https://pinterest.com" target="_blank" rel="noopener nofollow" className="w-10 h-10 flex items-center justify-center rounded-full border border-white/30 text-white hover:bg-white/10 transition-colors cursor-pointer">
                <i className="ri-pinterest-line" />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener nofollow" className="w-10 h-10 flex items-center justify-center rounded-full border border-white/30 text-white hover:bg-white/10 transition-colors cursor-pointer">
                <i className="ri-twitter-x-line" />
              </a>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-xs font-bold uppercase tracking-wider text-white/50 mb-6 font-body">{t("home.footer.contact")}</h4>
            <div className="space-y-4">
              <div>
                <span className="text-xs uppercase tracking-wider text-white/50 font-body">{t("home.footer.address")}</span>
                <p className="text-sm text-white mt-1 font-body">{t("home.footer.street")}</p>
              </div>
              <div>
                <span className="text-xs uppercase tracking-wider text-white/50 font-body">{t("home.footer.phone")}</span>
                <p className="text-sm text-white mt-1 font-body">{t("home.footer.phoneNum")}</p>
              </div>
              <div>
                <span className="text-xs uppercase tracking-wider text-white/50 font-body">{t("home.footer.email")}</span>
                <p className="text-sm text-white mt-1 font-body">{t("home.footer.emailAddr")}</p>
              </div>
            </div>
          </div>

          {/* SEO Articles Links */}
          <div>
            <h4 className="text-xs font-bold uppercase tracking-wider text-white/50 mb-6 font-body">{t("home.footer.articles")}</h4>
            <div className="space-y-3">
              <button type="button" onClick={() => { navigate("/hipobuy-guide"); window.scrollTo(0, 0); }} className="block text-sm text-white hover:text-accent-400 transition-colors cursor-pointer text-left font-body">
                {t("home.footer.article1")}
              </button>
              <button type="button" onClick={() => { navigate("/hipobuy-debutant"); window.scrollTo(0, 0); }} className="block text-sm text-white hover:text-accent-400 transition-colors cursor-pointer text-left font-body">
                {t("home.footer.article2")}
              </button>
              <button type="button" onClick={() => { navigate("/top-10-templates"); window.scrollTo(0, 0); }} className="block text-sm text-white hover:text-accent-400 transition-colors cursor-pointer text-left font-body">
                {t("home.footer.article3")}
              </button>
              <button type="button" onClick={() => { navigate("/hipobuy-debutant"); window.scrollTo(0, 0); }} className="block text-sm text-white hover:text-accent-400 transition-colors cursor-pointer text-left font-body">
                Débuter avec Hipobuy
              </button>
              <button type="button" onClick={() => { navigate("/guide-debutant-complet"); window.scrollTo(0, 0); }} className="block text-sm text-white hover:text-accent-400 transition-colors cursor-pointer text-left font-body">
                Guide débutant ultime
              </button>
              <button type="button" onClick={() => { navigate("/guide-achat-produits"); window.scrollTo(0, 0); }} className="block text-sm text-white hover:text-accent-400 transition-colors cursor-pointer text-left font-body">
                Guide d'achat
              </button>
            </div>
            <div className="mt-6 rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Minimal%20fashion%20accessories%20boutique%20display%20with%20pastel%20toned%20handbags%20and%20silk%20scarves%20on%20warm%20grey%20concrete%20pedestals%20soft%20spotlighting%20from%20above%20gallery%20editorial%20aesthetic%20clean%20sophisticated%20composition%20high%20end%20retail%20photography&width=300&height=400&seq=footer-img-v2&orientation=portrait"
                alt="Hipobuy fashion boutique"
                className="w-full h-48 object-cover object-top"
                width={300}
                height={400}
              />
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/50 font-body">{t("home.footer.copyright")}</p>
          <div className="flex gap-4">
            <button type="button" onClick={() => navigate("/hipobuy-guide")} className="text-xs text-white/50 hover:text-white transition-colors cursor-pointer font-body">
              {t("home.footer.article1")}
            </button>
            <button type="button" onClick={() => navigate("/hipobuy-debutant")} className="text-xs text-white/50 hover:text-white transition-colors cursor-pointer font-body">
              {t("home.footer.article2")}
            </button>
            <button type="button" onClick={() => navigate("/top-10-templates")} className="text-xs text-white/50 hover:text-white transition-colors cursor-pointer font-body">
              {t("home.footer.article3")}
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}